import MoodleUNDBService from '../../../services/moodle_undb/moodleundbService';
const api = new MoodleUNDBService()
const state = {
  perlets: [],
  perlets_loading:false,
  cursos: [],
  cursos_loading:false,
  turmas: [],
  turmas_loading:false,
  turmas_g: [],
  turmas_g_loading:false,
  disciplinas: [],
  disciplinas_loading:false,
  disciplinas_g: [],
  disciplinas_g_loading:false,
  alunos: [],
  alunos_loading:false,
  alunos_g: [],
  alunos_g_loading:false,
  professores: [],
  professores_loading:false,
  professores_g: [],
  professores_g_loading:false,
  coordenadores: [],
  coordenadores_loading:false,
  coordenadores_g: [],
  coordenadores_g_loading:false,
  gerenciadas_g: [],
  gerenciadas_g_loading:false,
  logs_moodle: [],
  logs_moodle_loading:false,
  logs_reset_password: [],
  logs_reset_password_loading:false,
  reset_password_moodleundb_loading:false,
  found_user_moodle:null,
  found_user_moodle_loading:false,
  integra_loading: false,
};
const getters = {
  StateIntegraLoading: state => state.integra_loading,
  StatePerlets: state => state.perlets,
  StatePerletsLoading: state => state.perlets_loading,
  StateCursos: state => state.cursos,
  StateCursosLoading: state => state.cursos_loading,
  StateTurmas: state => state.turmas,
  StateTurmasLoading: state => state.turmas_loading,
  StateDisciplinas: state => state.disciplinas,
  StateDisciplinasLoading: state => state.disciplinas_loading,
  StateAlunos: state => state.alunos,
  StateAlunosLoading: state => state.alunos_loading,
  StateProfessores: state => state.professores,
  StateProfessoresLoading: state => state.professores_loading,
  StateCoordenadores: state => state.coordenadores,
  StateCoordenadoresLoading: state => state.coordenadores_loading,
  StateTurmasG: state => state.turmas_g,
  StateTurmasGLoading: state => state.turmas_g_loading,
  StateDisciplinasG: state => state.disciplinas_g,
  StateDisciplinasGLoading: state => state.disciplinas_g_loading,
  StateAlunosG: state => state.alunos_g,
  StateAlunosGLoading: state => state.alunos_g_loading,
  StateProfessoresG: state => state.professores_g,
  StateProfessoresGLoading: state => state.professores_g_loading,
  StateCoordenadoresG: state => state.coordenadores_g,
  StateCoordenadoresGLoading: state => state.coordenadores_g_loading,
  StateGerenciadasG: state => state.gerenciadas_g,
  StateGerenciadasGLoading: state => state.gerenciadas_g_loading,
  StateFoundUserMoodle: state => state.found_user_moodle,
  StateFoundUserMoodleLoading: state => state.found_user_moodle_loading,
  StateLogsMoodle: state => state.logs_moodle,
  StateLogsMoodleLoading: state => state.logs_moodle_loading,
  StateLogsResetPasswordMoodle: state => state.logs_reset_password,
  StateLogsResetPasswordMoodleLoading: state => state.logs_reset_password_loading,
  StateResetPasswordMoodleUNDBLoading: state => state.reset_password_moodleundb_loading,
};
const mutations = {
  SetIntegraLoading(state, value){state.integra_loading = value},
  SetPerlets(state, value){state.perlets = value},
  SetPerletsLoading(state, value){state.perlets_loading = value},
  SetCursos(state, value){state.cursos = value},
  SetCursosLoading(state, value){state.cursos_loading = value},
  SetTurmas(state, value){state.turmas = value},
  SetTurmasLoading(state, value){state.turmas_loading = value},
  SetDisciplinas(state, value){state.disciplinas = value},
  SetDisciplinasLoading(state, value){state.disciplinas_loading = value},
  SetAlunos(state, value){state.alunos = value},
  SetAlunosLoading(state, value){state.alunos_loading = value},
  SetProfessores(state, value){state.professores = value},
  SetProfessoresLoading(state, value){state.professores_loading = value},
  SetCoordenadores(state, value){state.coordenadores = value},
  SetCoordenadoresLoading(state, value){state.coordenadores_loading = value},
  SetTurmasG(state, value){state.turmas_g = value},
  SetTurmasGLoading(state, value){state.turmas_g_loading = value},
  SetDisciplinasG(state, value){state.disciplinas_g = value},
  SetDisciplinasGLoading(state, value){state.disciplinas_g_loading = value},
  SetAlunosG(state, value){state.alunos_g = value},
  SetAlunosGLoading(state, value){state.alunos_g_loading = value},
  SetProfessoresG(state, value){state.professores_g = value},
  SetProfessoresGLoading(state, value){state.professores_g_loading = value},
  SetCoordenadoresG(state, value){state.coordenadores_g = value},
  SetCoordenadoresGLoading(state, value){state.coordenadores_g_loading = value},
  SetGerenciadasG(state, value){state.gerenciadas_g = value},
  SetGerenciadasGLoading(state, value){state.gerenciadas_g_loading = value},
  SetFoundUserMoodle(state, value){state.found_user_moodle = value},
  SetFoundUserMoodleLoading(state, value){state.found_user_moodle_loading = value},
  SetLogsMoodle(state, value){state.logs_moodle = value},
  SetLogsMoodleLoading(state, value){state.logs_moodle_loading = value},
  SetLogsResetPasswordMoodle(state, value){state.logs_reset_password = value},
  SetLogsResetPasswordMoodleLoading(state, value){state.logs_reset_password_loading = value},
  SetResetPasswordMoodleUNDBLoading(state, value){state.reset_password_moodleundb_loading = value},
};
const actions = {
    async GetPerlets({commit}, params) {
      commit('SetPerletsLoading', true)
      try{
          let response = await api.get_query_perlets(params)
          commit('SetPerlets', response.data)
        }catch(error){
          commit('SetPerlets', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhum período letivo encontrado!',
              tag: 'warn',
              timeout: '3000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetPerletsLoading', false)
    },
    async GetCursos({commit}, params) {
      commit('SetCursosLoading', true)
      try{
          let response = await api.get_query_cursos(params)
          commit('SetCursos', response.data)
        }catch(error){
          commit('SetCursos', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhum curso encontrado!',
              tag: 'warn',
              timeout: '3000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetCursosLoading', false)
    },
    async GetTurmas({commit}, params) {
      commit('SetTurmasLoading', true)
      try{
        let response = await api.get_query_turmas(params)
        commit('SetTurmas', response.data)
      }catch(error){
        commit('SetTurmas', [])
        if (error.response && error.response.status === 404){
          commit("setAlerts", [ {
            message: 'Nenhuma turma encontrada!',
            tag: 'warn',
            timeout: '3000',
            title: 'Nada encontrado'
          } ])
        }else{
          commit("setAlerts", [ error.toast_message ])
        }
      }
      commit('SetTurmasLoading', false)
    },
    async GetTurmasG({commit}, params) {
      commit('SetTurmasGLoading', true)
      try{
          let response = await api.get_query_turmas_g(params)
          commit('SetTurmasG', response.data)
        }catch(error){
          commit('SetTurmasG', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhuma turma encontrada!',
              tag: 'warn',
              timeout: '3000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetTurmasGLoading', false)
    },
    async GetDisciplinas({commit}, params) {
      commit('SetDisciplinasLoading', true)
      try{
          let response = await api.get_query_disciplinas(params)
          commit('SetDisciplinas', response.data)
        }catch(error){
          commit('SetDisciplinas', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhuma disciplina encontrada!',
              tag: 'warn',
              timeout: '3000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetDisciplinasLoading', false)
    },
    async GetDisciplinasG({commit}, params) {
      commit('SetDisciplinasGLoading', true)
      try{
          let response = await api.get_query_disciplinas_g(params)
          commit('SetDisciplinasG', response.data)
        }catch(error){
          commit('SetDisciplinasG', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhuma disciplina encontrada!',
              tag: 'warn',
              timeout: '3000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetDisciplinasGLoading', false)
    },
    async GetAlunos({commit}, params) {
      commit('SetAlunosLoading', true)
      try{
          let response = await api.get_query_alunos(params)
          commit('SetAlunos', response.data)
        }catch(error){
          commit('SetAlunos', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhum aluno encontrado!',
              tag: 'warn',
              timeout: '3000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetAlunosLoading', false)
    },
    async GetAlunosG({commit}, params) {
      commit('SetAlunosGLoading', true)
      try{
          let response = await api.get_query_alunos_g(params)
          commit('SetAlunosG', response.data)
        }catch(error){
          commit('SetAlunosG', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhum aluno encontrado!',
              tag: 'warn',
              timeout: '3000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetAlunosGLoading', false)
    },
    async GetProfessores({commit}, params) {
      commit('SetProfessoresLoading', true)
      try{
          let response = await api.get_query_professores(params)
          commit('SetProfessores', response.data)
        }catch(error){
          commit('SetProfessores', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhum professor encontrado!',
              tag: 'warn',
              timeout: '3000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetProfessoresLoading', false)
    },
    async GetProfessoresG({commit}, params) {
      commit('SetProfessoresGLoading', true)
      try{
          let response = await api.get_query_professores_g(params)
          commit('SetProfessoresG', response.data)
        }catch(error){
          commit('SetProfessoresG', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhum professor encontrado!',
              tag: 'warn',
              timeout: '3000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetProfessoresGLoading', false)
    },
    async GetCoordenadores({commit}, params) {
      commit('SetCoordenadoresLoading', true)
      try{
          let response = await api.get_query_coordenadores(params)
          commit('SetCoordenadores', response.data)
        }catch(error){
          commit('SetCoordenadores', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhum coordenador encontrado!',
              tag: 'warn',
              timeout: '3000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetCoordenadoresLoading', false)
    },
    async GetCoordenadoresG({commit}, params) {
      commit('SetCoordenadoresGLoading', true)
      try{
          let response = await api.get_query_coordenadores_g(params)
          commit('SetCoordenadoresG', response.data)
        }catch(error){
          commit('SetCoordenadoresG', [])
          if (error.response && error.response.status === 404){
            commit("setAlerts", [ {
              message: 'Nenhum Coordenador encontrado!',
              tag: 'warn',
              timeout: '3000',
              title: 'Nada encontrado'
            } ])
          }else{
            commit("setAlerts", [ error.toast_message ])
          }
      }
      commit('SetCoordenadoresGLoading', false)
    },
    async GetGerenciadasG({commit}, params) {
      commit('SetGerenciadasGLoading', true)
      try{
          let response = await api.get_query_gerenciadas_g(params)
          commit('SetGerenciadasG', response.data)
        }catch(error){
          commit('SetGerenciadasG', [])
          commit("setAlerts", [ error.toast_message ])
      }
      commit('SetGerenciadasGLoading', false)
    },
    async ResetPasswordMoodleUNDB({commit}, params) {
      commit('SetResetPasswordMoodleUNDBLoading', true)
      try{
          let response = await api.reset_moodle_password(params)
          if(response.status == 200){
            commit("setAlerts", [ {
              tag:'success',
              title:'UNDB Classroom',
              message: response.data+ ' <br/> Usuário: <b>' + params.username + '</b>'+' <br/> Senha: <b>undb@class</b>',
              timeout: "6000"
            }])
          }
      }catch(error){
          commit("setAlerts", [ error.toast_message ])
      }
      commit('SetResetPasswordMoodleUNDBLoading', false)
    },
    async FindUserMoodleUNDB({commit}, params) {
      commit('SetFoundUserMoodleLoading', true)
      try{
          let response = await api.find_user(params)
          commit('SetFoundUserMoodle', response.data)
        }catch(error){
          commit('SetFoundUserMoodle', null)
          commit("setAlerts", [ error.toast_message ])
      }
      commit('SetFoundUserMoodleLoading', false)
    },
    async ResetPasswordMoodleUNDBPos({commit}, params) {
      commit('SetResetPasswordMoodleUNDBLoading', true)
      try{
          let response = await api.reset_moodle_password_pos(params)
          if(response.status == 200){
            commit("setAlerts", [ {
              tag:'success',
              title:'UNDB Pós',
              message: response.data+ ' Usuário: "' + params.username + '", Senha: "undb@class"',
              timeout: "6000"
            }])
          }
      }catch(error){
          commit("setAlerts", [ error.toast_message ])
      }
      commit('SetResetPasswordMoodleUNDBLoading', false)
    },
    async FindUserMoodleUNDBPos({commit}, params) {
      commit('SetFoundUserMoodleLoading', true)
      try{
          let response = await api.find_user_pos(params)
          commit('SetFoundUserMoodle', response.data)
        }catch(error){
          commit('SetFoundUserMoodle', null)
          commit("setAlerts", [ error.toast_message ])
      }
      commit('SetFoundUserMoodleLoading', false)
    },
    async GetLogsMoodleUNDB({commit}, params) {
      commit('SetLogsMoodleLoading', true)
      try{
        let response = await api.get_logs(params)
        commit('SetLogsMoodle', response.data)
      }catch(error){
        commit('SetLogsMoodle', null)
        commit("setAlerts", [ error.toast_message ])
      }
      commit('SetLogsMoodleLoading', false)
    },
    async GetLogsResetPasswordMoodleUNDB({commit}, params) {
      commit('SetLogsResetPasswordMoodleLoading', true)
      try{
        let response = await api.get_logs_reset_password(params)
        commit('SetLogsResetPasswordMoodle', response.data)
      }catch(error){
        commit('SetLogsResetPasswordMoodle', [])
        commit("setAlerts", [ error.toast_message ])
      }
      commit('SetLogsResetPasswordMoodleLoading', false)
    },
    async IntegraMoodleUNDB({commit},params) {
      commit('SetIntegraLoading', true)
      try{
        let response = await api.integra(params)
        commit("setAlerts", [{
          tag:'success',
          title:'Integração UNDB Classroom',
          message: response.data.message,
          timeout: "5000"
        }])
      }catch(error){
        commit("setAlerts", [ error.toast_message ])
      }
      commit('SetIntegraLoading', false)
    },
};
export default {
  state,
  getters,
  actions,
  mutations
};